import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { Redirect } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { get, find } from "lodash";
import { partnerInfo } from "~/configs/partnerDetails";
import { changeUrlRedirectAfterCreatePatient } from "~/store/patientForm/patientFormAction";
import { getNotificationOnPage } from "~/store/notifications/notificationsActions";
import { checkRepayment } from "~/store/totalData/actions";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const UserPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_mobile" */ "~/components/desktop/pages/User"
    ),
  loading: LoadableLoading
});
const UserPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_desktop" */ "~/components/desktop/pages/User"
    ),
  loading: LoadableLoading
});

class DetectUser extends Component {
  methods = {
    handleCreateNewPatient: () => {
      this.props.history.push("/tao-moi-ho-so");
      this.props.changeUrlRedirectAfterCreatePatient("/user");
    }
  };

  componentDidMount() {
    this.props.getNotificationOnPage({
      category: 1
    });
    this.props.checkRepayment(false);
  }

  render() {
    const { device, infoUser } = this.props;
    if (infoUser === null) {
      return <Redirect to="/" />;
    }
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <UserPageMobile {...this.props} {...this.methods} />
        ) : (
          <UserPageDesktop {...this.props} {...this.methods} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { info: infoUser }
  } = state;
  return {
    device: type,
    infoUser
  };
};

const DetectUserHelmet = withTitle({
  component: DetectUser,
  title: `${hospitalName.value} | Thông tin tài khoản`
});

export default connect(mapStateToProps, {
  changeUrlRedirectAfterCreatePatient,
  getNotificationOnPage,
  checkRepayment
})(DetectUserHelmet);
